<template lang="pug">
v-btn(@click="handler", :loading="loading", small) Rebuild BizOrder
</template>

<script>
export default {
  data() {
    return { loading: false };
  },
  methods: {
    async handler() {
      this.loading = true;
      try {
        const result = await this.$api.transaction.stripe.custom("bizOrder");
        this.$toast.success(result);
      } catch (err) {
        this.$toast.error(err.response?.data || err.message);
      }
      this.loading = false;
    },
  },
};
</script>